import { fetcher } from "helpers/fetcher";

import { TGetSearchCorporationReq, TGetSearchCorporationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getSearchCorporation = async (
  payload: TGetSearchCorporationReq
) => {
  return await fetcher<TGetSearchCorporationRes, TGetSearchCorporationReq>(
    ENDPOINT.CORPORATION.GET_SEARCH_CORP,
    {
      params: payload.params,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.GET_SEARCH_CORP.version,
        [API_HEADER.BU_ID]: payload.idBU,
      },
    }
  );
};

export const queryGetSearchCorporation = async (
  payload: TGetSearchCorporationReq
) => {
  return (await getSearchCorporation(payload)).data;
};

queryGetSearchCorporation._key = (payload: TGetSearchCorporationReq) => [
  ENDPOINT.CORPORATION.GET_SEARCH_CORP.url,
  payload,
];
